export enum TaskCenterTab {
  ESCALATIONS = "escalations",
  ANALYSIS = "analysis"
}

export enum TaskCenterStatus {
  ACTION_NEEDED = "at_risk",
  IN_PROGRESS = "in_progress",
  RESOLVED = "resolved",
  DISMISSED = "dismissed",
  EXPIRED = "expired",
}

export const TaskCenterStatusVariantMap = {
  at_risk: "alert",
  in_progress: "pending",
  resolved: "success",
  dismissed: "neutral",
  expired: "neutral",
}

export const TaskCenterStatusMap = {
  at_risk: "Action needed",
  in_progress: "In progress",
  resolved: "Resolved",
  dismissed: "Dismissed",
  expired: "Expired",
}

export interface TaskCenterStats {
  active_count: number;
  in_progress_count: number;
  resolved_count: number;
  dismiss_count: number;
  unaddressed_count: number;
  total_count: number;
}

export interface TaskCenterFilter {
  timeRange: string;
  branch: string;
  rankBy: string;
  escalationTime: string;
  showAtRisk: boolean;
  showInProgress: boolean;
  showResolved: boolean;
  showDismissed: boolean;
  showExpired: boolean;
}

export interface TaskCenterEmployeeInfo {
  employee_id: number;
  job_title: string;
  region: string;
  name: string;
  category: string | null;
  office_location: string;
}

export interface TaskCenterRow {
  status: TaskCenterStatus;
  employee_info: TaskCenterEmployeeInfo;
  tenure: string;
  escalation_reason: string;
  assignee: string | null;
  escalation_time: string;
  escalation_created_at: string;
  priority: 'overdue' | 'reminder';
  survey_ids: string;
  escalation_id: string;
  tags?: string[]; // Optional tags array for in-progress escalations
  reminder_data?: {
    reminder_id: number;
    reminder_datetime: string;
    reminder_sent: boolean;
    reminder_sent_at: string | null;
    reminder_to_employee_id: number;
    reminder_recipient?: {
      name: string;
      email: string;
      phone: string;
    };
  } | null; // Reminder data from API if reminder exists
  office_location_data: {
    name: string;
    survey_sentiment_data: {
      "Overall Sentiment": string;
      "Sentiment Score": number;
      "Response Rate": number;
    }
  }
}

export interface TaskCenterData {
  stats: TaskCenterStats;
  filters: TaskCenterFilter;
  rows: TaskCenterRow[];
}

// Caregiver Assignment Types
export interface CaregiverPolicy {
  role: string;
  method: string;
  type: string;
  value: string[];
}

export interface Caregiver {
  first_name: string;
  last_name: string;
  email: string;
  role_type: string;
  caregiver_id: number;
  agency_id: number;
  policy: CaregiverPolicy[] | null;
}

export interface CaregiverAssignmentResponse {
  success: boolean;
  message: string;
  result: {
    total: number;
    page: number;
    caregiver_roles: Caregiver[];
  };
}

export interface AssignmentResponse {
  success: boolean;
  message: string;
  result: {
    escalation_id: number;
    assigned_to_employee_id: number;
    updated_at: string;
    assigned_employee: {
      id: number;
      name: string;
      email: string;
    };
    assigned_caregiver_id: number;
  } | null;
} 